import { FieldsetHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface FieldsetCardProps extends FieldsetHTMLAttributes<HTMLFieldSetElement> {
  title: string;
  contentClassName?: string;
}

export const getDisabledClasses = (isDisabled?: boolean) => ({
  className: twMerge(isDisabled && "bg-transparent border-none"),
  inputClassName: twMerge(
    isDisabled &&
      "disabled:bg-transparent disabled:border-none disabled:p-0 disabled:h-auto",
  ),
});

export const FieldsetCard = ({
  title,
  children,
  className,
  contentClassName,
  ...props
}: FieldsetCardProps) => {
  return (
    <fieldset
      className={twMerge(
        "flex flex-col gap-3 rounded-lg border p-4 shadow-inner shadow-gray-50",
        className,
      )}
      {...props}
    >
      <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      <div className={twMerge("grid gap-3", contentClassName)}>{children}</div>
    </fieldset>
  );
};
